import assetPath from '/opt/actions-runner/_work/crate/crate/xinglets/companies/companies/src/assets/images/managed-empty-state.png';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')